<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Delete Integration - {{ integration.name }}
      </h2>
    </template>
    <template #modal-body>
      <div>
        <h3>Are you sure you wish to delete this integration?</h3>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--danger']"
          @click="handleDeleteEventIntegration"
        >
          Delete
          Integration
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    integration: {
      type: Object,
      default() {
        return {};
      },
    },
    eventId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {

    ...mapActions(
      'events',
      [
        'deleteIntegration',
      ],
    ),
    handleDeleteEventIntegration() {
      this.ui.submitLoading = true;
      this.deleteIntegration({ eventId: this.eventId, integrationId: this.integration.id })
        .then((data) => {
          this.ui.submitLoading = false;

          this.$bus.$emit('displayMsg', {
            text: data.meta.message,
            type: 'success',
          });

          this.$emit('delete-integration-modal:success');

          this.isOpen = false;
        })
        .catch(() => {
          this.ui.submitLoading = false;
          this.$bus.$emit('displayMsg', {
            text: 'Something went wrong!',
            type: 'warning',
          });
          this.ui.submitLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>

</style>
